import type { GoodRuleCardProps } from '@/pages/pii-training/piiTraining.types';
import { Box, Card, CardContent, CardTitle, Icon, Text } from '@careflux/primitives';

/** The "Góð regla" callout, shown on the combinations step and repeated on the consent step. */
export const GoodRuleCard = ({ title, body }: GoodRuleCardProps) => (
  <Card variant="outlined" padding="lg" gap="sm">
    <CardTitle>
      <Box display="flex" align="center" gap="sm">
        <Icon name="Lightbulb" size="sm" color="primary" />
        <Text weight="semibold">{title}</Text>
      </Box>
    </CardTitle>
    <CardContent>
      <Text asChild>
        <p>{body}</p>
      </Text>
    </CardContent>
  </Card>
);
